<div class="pr-information">
  <div class="pr-details-container">
    <span class="pr-details-text">{{ detailsText }}</span>
  </div>

  <div class="pr-amount">
    {{ amountLabel | value }}
  </div>
  <div class="pr-continue-button">
    <zaver-primary-button
      [text]="buttonText"
      [disabled]="isButtonDisabled"
      [loading]="isButtonLoading"
      [logo]="buttonLogo"
      (click)="continueClick()"
    ></zaver-primary-button>
  </div>
  <zaver-button-link (click)="detailsClick()" [text]="detailsLabel">
  </zaver-button-link>
</div>
